import { EnrichedComponentCategory } from '../domain/category/CategoryOperationDomains';
import { PagePath } from '../redux/reducers/PageReducer';

class FolderUtil {
  static calculateCurrentCategoryPath = (
    enrichCategory: EnrichedComponentCategory,
    pages: PagePath[],
    categoryMap: Record<string, EnrichedComponentCategory>,
    componentName?: string,
  ) => {
    enrichCategory.path.forEach((p, i) => {
      const curr = categoryMap[enrichCategory.path.slice(0, i + 1).join('.')];
      pages.push({
        title: curr?.name,
        path: `${componentName}/folder/${curr?.id}`,
        type: 'category',
        categoryPath: enrichCategory.path.slice(0, i + 1).join('.'),
        payload: curr,
      });
    });
    pages.splice(1, 1);
    return pages;
  };
}

export default FolderUtil;
